import { defineMessages } from 'react-intl'

const scope = `procurify.components.ExporterExportForm`

export default defineMessages({
  ExporterExportFormatSelectLabel: {
    id: `${scope}.ExporterExportFormatSelectLabel`,
    defaultMessage: 'Format type',
  },
  ExporterExportFormatSelectPlaceholder: {
    id: `${scope}.ExporterExportFormatSelectPlaceholder`,
    defaultMessage: 'Select format type',
  },
  createFormatOptionLabel: {
    id: `${scope}.createFormatOptionLabel`,
    defaultMessage: '+ Create new format',
  },
  emailExportLabel: {
    id: `${scope}.emailExportLabel`,
    defaultMessage: 'Email a copy of the CSV after exporting',
  },
  cancelButtonText: {
    id: `${scope}.cancelButtonText`,
    defaultMessage: 'Cancel',
  },
  exportButtonText: {
    id: `${scope}.exportButtonText`,
    defaultMessage: 'Export CSV',
  },
  exportFiltersTitle: {
    id: `${scope}.exportFiltersTitle`,
    defaultMessage: 'Export filters',
  },
  exportFormatPreviewTitle: {
    id: `${scope}.exportFormatPreviewTitle`,
    defaultMessage: 'Export format preview',
  },
  setDefaultFormatTitle: {
    id: `${scope}.setDefaultFormatTitle`,
    defaultMessage: 'Set default format',
  },
  editFormatTitle: {
    id: `${scope}.editFormatTitle`,
    defaultMessage: 'Edit format',
  },
  deleteFormatTitle: {
    id: `${scope}.deleteFormatTitle`,
    defaultMessage: 'Delete format',
  },
  loadingSampleDataText: {
    id: `${scope}.loadingSampleDataText`,
    defaultMessage: 'Loading sample data',
  },
  emailCSVToRecipient: {
    id: `${scope}.emailCSVToRecipient`,
    defaultMessage:
      'Export will be sent to your email: <strong>{recipient}</strong>',
  },
  emailCSVToEmail: {
    id: `${scope}.emailCSVToEmail`,
    defaultMessage: 'Export will be sent to your email',
  },
})
